import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'fr',
    debug: process.env.NODE_ENV === 'development',

    interpolation: {
      escapeValue: false, // React already escapes values
    },

    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
      request: (options, url, payload, callback) => {
        try {
          fetch(url)
            .then((response) => {
              if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
              }
              return response.json();
            })
            .then((data) => {
              callback(null, {
                data: data,
                status: 200,
              });
            })
            .catch((error) => {
              console.warn(`Failed to load translation file: ${url}`, error);
              callback(null, {
                data: {},
                status: 200,
              });
            });
        } catch (error) {
          console.warn(`Failed to load translation file: ${url}`, error);
          callback(null, {
            data: {},
            status: 200,
          });
        }
      },
    },

    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
    },

    supportedLngs: ['fr', 'en', 'it', 'es', 'pt'],

    ns: ['common', 'dashboard', 'products', 'auth'],
    defaultNS: 'common',
  });

export default i18n;
